import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css'
import './App.scss'

import { Header } from './Header'
import { Footer } from './Footer'
import { Report } from './Report'
import { NewReport } from './NewReport'

import Analytics from 'react-router-ga'

class App extends React.Component<{}> {
  public render() {
    return (
      <div className="App">
        <Header></Header>
        <Router basename={process.env.PUBLIC_URL}>
          <Analytics id="UA-1244143-21">
            <Switch>
              <Route exact path={`/`} component={NewReport}></Route>
              <Route path={`/report`} component={Report}></Route>
            </Switch>
          </Analytics>
        </Router>
        <Footer></Footer>
      </div>
    )

  }
}

export default App
